(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ah-promise"] && !Shopify.designMode) return;
  try {
    (() => {
    const el = document.querySelector('[data-ah-countdown]');
    if (!el) return;
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).map((p) => [p.type, p.value]));
    const working = !['Sat', 'Sun'].includes(parts.weekday);
    const mins = 14 * 60 - (Number(parts.hour) * 60 + Number(parts.minute));
    if (working && mins > 0) el.textContent = `Order within ${Math.floor(mins / 60)}h ${mins % 60}m for same-day dispatch`;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ah-stock-helper"] && !Shopify.designMode) return;
  try {
    (() => {
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
    const read = (root) => {
      try { return JSON.parse(root.querySelector('[data-ah-stock]').textContent); } catch { return null; }
    };
    const pickerFor = (root) => root.closest('.shopify-section')?.querySelector('variant-picker') || document.querySelector('variant-picker');

    /* Selected option values, read from Horizon's picker (radios or <select>). */
    const selected = (root, names) => {
      const picker = pickerFor(root);
      if (!picker) return null;
      const values = names.map((n) => picker.querySelector(`[data-option-name="${CSS.escape(n)}"]:checked`)?.value);
      return values.every((x) => x !== undefined) ? values : null;
    };

    const render = (root, fallbackId) => {
      const data = read(root);
      const line = root.querySelector('[data-ah-stock-line]');
      if (!data || !line || !data.rows.length) return;
      const threshold = Number(root.dataset.threshold) || 10;
      const si = Number(root.dataset.sizeIndex);
      const opts = selected(root, data.names);
      let v = opts ? data.rows.find((r) => r.options.join('/') === opts.join('/')) : null;
      if (!v && !opts) v = data.rows.find((r) => r.id === Number(fallbackId)) || data.rows[0];
      const values = v ? v.options : opts;

      if (v && v.available) {
        const low = v.qty !== null && v.qty > 0 && v.qty <= threshold ? ` · only ${v.qty} left` : '';
        line.innerHTML = `<b class="ok">In stock</b>${low} · ready to dispatch from Rochdale`;
        return;
      }
      const label = v ? 'Sold out' : 'Not available';
      if (si < 0) { line.innerHTML = `<b class="no">${label}</b>.`; return; }
      const rest = values.filter((_, i) => i !== si);
      const alts = data.rows.filter((r) => r.available && r.options.filter((_, i) => i !== si).join('/') === rest.join('/'));
      line.innerHTML = `<b class="no">${label} in ${esc(values[si])}</b>${rest.length ? ` for ${esc(rest.join(' / '))}` : ''}.` +
        (alts.length ? `<span class="ah-stock__alts">In stock in: ${alts.map((a) => `<button type="button" data-ah-stock-alt="${esc(a.options[si])}">${esc(a.options[si])}</button>`).join('')}</span>` : '');
    };

    const renderAll = () => document.querySelectorAll('[data-ah="stock-helper"]').forEach((root) => render(root, root.dataset.variantId));

    document.addEventListener('click', (e) => {
      const btn = e.target instanceof Element && e.target.closest('[data-ah-stock-alt]');
      if (!btn) return;
      const root = btn.closest('[data-ah="stock-helper"]');
      const data = read(root);
      const picker = pickerFor(root);
      if (!data || !picker) return;
      const name = data.names[Number(root.dataset.sizeIndex)];
      const sel = `[data-option-name="${CSS.escape(name)}"][value="${CSS.escape(btn.dataset.ahStockAlt)}"]`;
      const input = picker.querySelector(`input${sel}`);
      if (input) { input.click(); return; }
      const option = picker.querySelector(`option${sel}`);
      if (option) {
        option.selected = true;
        option.closest('select').dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    /* Horizon 4.2 fires Shopify's standard 'shopify:product:select' on variant change. */
    document.addEventListener('shopify:product:select', (e) => {
      if (!(e.target instanceof Element) || e.target.closest('product-card')) return;
      renderAll();
      e.promise?.then(renderAll).catch(() => {});
    });

    document.addEventListener('shopify:section:load', renderAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll);
    else renderAll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ah-unit-price"] && !Shopify.designMode) return;
  try {
    /* Horizon 4.2 announces variant changes with Shopify's standard 'shopify:product:select'
     event; event.promise resolves with detail.resource = the selected variant JSON (or null). */
  document.addEventListener('shopify:product:select', (e) => {
    if (!(e.target instanceof Element) || e.target.closest('product-card')) return;
    e.promise?.then(({ detail } = {}) => {
      const el = document.querySelector('[data-ah="unit-price"]');
      if (!el) return;
      const variant = detail?.resource;
      const n = variant ? parseInt(variant.title, 10) : 0;
      if (n > 1 && /pack/i.test(variant.title)) {
        const pence = Math.round(variant.price / n);
        el.textContent = `£${(pence / 100).toFixed(2)} per item`;
      } else el.textContent = '';
    }).catch(() => {});
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    // AH (P9 fix round 1): the sticky bar's "Choose options" button (no variant matches the selected options)
  // scrolls to the product's variant picker and focuses its first option.
  if (!window.ahChooseOptionsBound) {
    window.ahChooseOptionsBound = true;
    document.addEventListener('click', (e) => {
      const btn = e.target instanceof Element ? e.target.closest('sticky-add-to-cart [data-ah-choose]') : null;
      if (!btn) return;
      e.preventDefault();
      const id = btn.closest('sticky-add-to-cart')?.dataset.productId;
      const picker = document.querySelector(`variant-picker[data-product-id="${id}"]`) || document.querySelector('variant-picker');
      if (!picker) return;
      picker.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      const first = picker.querySelector('input:checked, input, select');
      if (first) first.focus({ preventScroll: true });
    });
  }
  // AH (P9, owner 2026-10-02): long button/swatch options show about two rows plus a "Show all N designs" toggle.
  // Delegated from document and re-applied after Horizon morphs the picker on variant change. Without JS, CSS shows
  // a safe first two rows (no layout shift when this refines it).
  (() => {
    const ROWS = 2;
    const apply = (fs) => {
      const btn = fs.querySelector(':scope > .ah-opt-more');
      const all = [...fs.querySelectorAll(':scope > label')];
      all.forEach((l) => l.removeAttribute('data-ah-over'));
      fs.setAttribute('data-ah-js', '');
      // AH (P11 U6): sold-out values hidden by CSS (display: none) take no row; fit rows from the visible labels only
      const labels = all.filter((l) => l.getClientRects().length > 0);
      if (fs.hasAttribute('data-expanded')) return;
      const tops = [...new Set(labels.map((l) => l.offsetTop))].sort((a, b) => a - b);
      if (tops.length <= ROWS) { if (btn) btn.hidden = true; return; }
      if (btn) btn.hidden = false;
      const over = labels.filter((l) => l.offsetTop > tops[ROWS - 1]);
      if (over.some((l) => l.querySelector('input:checked'))) {
        fs.setAttribute('data-expanded', '');
        if (btn) { btn.setAttribute('aria-expanded', 'true'); btn.textContent = btn.dataset.less; }
        return;
      }
      over.forEach((l) => l.setAttribute('data-ah-over', ''));
    };
    let observer = null;
    // takeRecords() drops the mutations this script makes itself, so only Horizon's morph re-triggers a run.
    // AH (P11 U6): a morph can add data-ah-collapse (more values in stock for the new size) or change availability.
    const run = () => { document.querySelectorAll('fieldset[data-ah-collapse]').forEach(apply); observer?.takeRecords(); };
    let queued = false;
    const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; run(); }); };
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('.ah-opt-more') : null;
      if (!button) return;
      const fieldset = button.closest('fieldset');
      if (!fieldset) return;
      const open = !fieldset.hasAttribute('data-expanded');
      fieldset.toggleAttribute('data-expanded', open);
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? button.dataset.less : button.dataset.more;
      apply(fieldset);
    });
    const start = () => {
      observer = new MutationObserver((list) => { if (list.some((m) => m.target instanceof Element && m.target.closest('variant-picker'))) schedule(); });
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-ah-js', 'data-ah-over', 'data-expanded', 'checked', 'data-ah-collapse', 'data-option-available'] });
      run();
      window.addEventListener('resize', schedule);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
  // AH (P11 U7, owner 2026-10-03): design swatches switch the main photo at once instead of after Horizon's section
  // fetch and gallery replace (~1-3 s). On hover/focus/touch the swatch's full image is warmed with the gallery's own
  // srcset/sizes (so the CDN size and the browser cache match what the gallery will request); on select the visible
  // main image shows the blurred swatch at once, then the sharp image as soon as it has loaded. Horizon then replaces
  // the gallery with the server render, whose first image is the same URL, so it comes from cache (no flash back).
  // Everything is delegated from document, so Horizon's morphs need no re-binding.
  (() => {
    if (window.ahSwatchSwapBound) return;
    window.ahSwatchSwapBound = true;
    const warmed = new Set();
    let token = 0;
    const inputOf = (t) => (t instanceof Element ? t.closest('label.ah-swatch-label')?.querySelector('input[data-ah-full]') : null);
    const galleryFor = (input) => input.closest('.shopify-section, dialog')?.querySelector('media-gallery');
    const mainImg = (g) => g?.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image') || g?.querySelector('img.product-media__image');
    const base = (url) => url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    const join = (b, w) => `${b}${b.includes('?') ? '&' : '?'}width=${w}`;
    // The candidate widths the gallery already uses, read from the current main image
    const widthsOf = (img) => (img?.getAttribute('srcset') || '').split(',').map((c) => parseInt(c.trim().split(/\s+/)[1], 10)).filter(Boolean);
    const sources = (input, img) => {
      const b = base(input.dataset.ahFull);
      const ws = widthsOf(img);
      if (!ws.length) return null;
      return { srcset: ws.map((w) => `${join(b, w)} ${w}w`).join(', '), sizes: img.getAttribute('sizes') || '100vw', src: join(b, ws[Math.min(3, ws.length - 1)]) };
    };
    const load = (s) => {
      const im = new Image();
      im.decoding = 'async';
      im.sizes = s.sizes;
      im.srcset = s.srcset;
      im.src = s.src;
      return im.decode().catch(() => {});
    };
    const warm = (e) => {
      const input = inputOf(e.target);
      if (!input || input.checked || warmed.has(input.dataset.ahFull)) return;
      const s = sources(input, mainImg(galleryFor(input)));
      if (!s) return;
      warmed.add(input.dataset.ahFull);
      load(s);
    };
    const swap = (input) => {
      const img = mainImg(galleryFor(input));
      const s = sources(input, img);
      if (!img || !s) return;
      const mine = ++token;
      const thumb = input.closest('label')?.querySelector('img.ah-swatch-img')?.currentSrc;
      if (thumb) {
        img.removeAttribute('srcset');
        img.src = thumb;
        img.classList.add('ah-swap-pending');
      }
      warmed.add(input.dataset.ahFull);
      load(s).then(() => {
        if (mine !== token || !img.isConnected) return;
        img.sizes = s.sizes;
        img.srcset = s.srcset;
        img.src = s.src;
        img.classList.remove('ah-swap-pending');
      });
    };
    ['pointerover', 'focusin', 'touchstart'].forEach((type) => document.addEventListener(type, warm, { passive: true }));
    document.addEventListener('change', (e) => {
      const input = e.target instanceof HTMLInputElement && e.target.matches('label.ah-swatch-label > input[data-ah-full]') ? e.target : null;
      if (input && input.checked) swap(input);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
